"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createImportSymbol = exports.getImportStatements = exports.hooks = exports.diagnostics = void 0;
const feature_1 = require("./feature");
const diagnostics_1 = require("./diagnostics");
const STSymbol = __importStar(require("./st-symbol"));
const plugable_record_1 = require("../helpers/plugable-record");
const deprecation_1 = require("../helpers/deprecation");
const import_1 = require("../helpers/import");
const stylable_utils_1 = require("../stylable-utils");
const stylable_value_parsers_1 = require("../stylable-value-parsers");
const path_1 = __importDefault(require("path"));
const dataKey = plugable_record_1.plugableRecord.key('imports');
exports.diagnostics = {
    ...import_1.parseImportMessages,
    NO_ST_IMPORT_IN_NESTED_SCOPE() {
        return `cannot use "@st-import" inside of nested scope`;
    },
    NO_PSEUDO_IMPORT_IN_NESTED_SCOPE() {
        return `cannot use ":import" inside of nested scope`;
    },
    INVALID_CUSTOM_PROPERTY_AS_VALUE(name, as) {
        return `invalid alias for custom property "${name}" as "${as}"; custom properties must be prefixed with "--" (double-dash)`;
    },
    FORBIDDEN_DEF_IN_COMPLEX_SELECTOR: diagnostics_1.generalDiagnostics.FORBIDDEN_DEF_IN_COMPLEX_SELECTOR,
    UNKNOWN_IMPORTED_SYMBOL(name, path) {
        return `cannot resolve imported symbol "${name}" from stylesheet "${path}"`;
    },
    UNKNOWN_IMPORTED_FILE(path) {
        return `cannot resolve imported file: "${path}"`;
    },
};
// HOOKS
exports.hooks = (0, feature_1.createFeature)({
    metaInit({ meta }) {
        plugable_record_1.plugableRecord.set(meta.data, dataKey, []);
    },
    analyzeInit(context) {
        const imports = plugable_record_1.plugableRecord.getUnsafe(context.meta.data, dataKey);
        const dirContext = path_1.default.dirname(context.meta.source);
        // collect shallow imports
        for (const node of context.meta.ast.nodes) {
            const isImportDef = (node.type === `atrule` && node.name === `st-import`) ||
                (node.type === `rule` && node.selector === `:import`);
            if (!isImportDef) {
                continue;
            }
            const parsedImport = node.type === `atrule`
                ? (0, import_1.parseStImport)(node, dirContext, context.diagnostics)
                : (0, import_1.parsePseudoImport)(node, dirContext, context.diagnostics);
            imports.push(parsedImport);
            (0, deprecation_1.ignoreDeprecationWarn)(() => {
                context.meta.imports.push(parsedImport);
            });
            addImportSymbols(parsedImport, context, dirContext);
        }
    },
    analyzeAtRule({ context, atRule }) {
        var _a;
        if (atRule.name !== `st-import`) {
            return;
        }
        if (((_a = atRule.parent) === null || _a === void 0 ? void 0 : _a.type) !== `root`) {
            context.diagnostics.warn(atRule, exports.diagnostics.NO_ST_IMPORT_IN_NESTED_SCOPE());
        }
        // remove `@st-import` at rules - ToDo: move to transformer
        atRule.remove();
    },
    analyzeSelectorNode({ context, rule, node }) {
        var _a;
        if (node.value !== `import`) {
            return;
        }
        if (rule.selector !== `:import`) {
            context.diagnostics.warn(rule, exports.diagnostics.FORBIDDEN_DEF_IN_COMPLEX_SELECTOR(stylable_value_parsers_1.rootValueMapping.import));
            return;
        }
        if (((_a = rule.parent) === null || _a === void 0 ? void 0 : _a.type) !== `root`) {
            context.diagnostics.warn(rule, exports.diagnostics.NO_PSEUDO_IMPORT_IN_NESTED_SCOPE());
        }
        // remove rules with `:import` selector - ToDo: move to transformer
        rule.remove();
    },
    transformInit({ context }) {
        validateImports(context);
    },
});
// API
function getImportStatements({ data }) {
    const state = plugable_record_1.plugableRecord.getUnsafe(data, dataKey);
    return state;
}
exports.getImportStatements = getImportStatements;
function createImportSymbol(importDef, type, name, dirContext) {
    return {
        _kind: 'import',
        type: type === 'default' ? `default` : `named`,
        name: type === `default` ? name : importDef.named[name],
        import: importDef,
        context: dirContext,
    };
}
exports.createImportSymbol = createImportSymbol;
// internal
function addImportSymbols(importDef, context, dirContext) {
    checkForInvalidAsUsage(importDef, context);
    if (importDef.defaultExport) {
        STSymbol.addSymbol({
            context,
            localName: importDef.defaultExport,
            symbol: createImportSymbol(importDef, `default`, `default`, dirContext),
            node: importDef.rule,
        });
    }
    Object.keys(importDef.named).forEach((name) => {
        STSymbol.addSymbol({
            context,
            localName: name,
            symbol: createImportSymbol(importDef, `named`, name, dirContext),
            node: importDef.rule,
        });
    });
    Object.keys(importDef.keyframes).forEach((name) => {
        if (!checkRedeclareKeyframes(context, name, importDef.rule)) {
            // ToDo: move to STSymbol.addSymbol({namespace: `keyframes`})
            context.meta.mappedKeyframes[name] = {
                _kind: 'keyframes',
                alias: name,
                name: importDef.keyframes[name],
                import: importDef,
            };
        }
    });
}
function checkForInvalidAsUsage(importDef, context) {
    for (const [local, imported] of Object.entries(importDef.named)) {
        if ((0, stylable_utils_1.isCSSVarProp)(imported) && !(0, stylable_utils_1.isCSSVarProp)(local)) {
            context.diagnostics.warn(importDef.rule, exports.diagnostics.INVALID_CUSTOM_PROPERTY_AS_VALUE(imported, local));
        }
    }
}
function validateImports(context) {
    const imports = plugable_record_1.plugableRecord.getUnsafe(context.meta.data, dataKey);
    for (const importObj of imports) {
        const resolvedImport = context.resolver.resolveImported(importObj, '');
        if (!resolvedImport) {
            // warn about unknown imported files
            const fromDecl = importObj.rule.nodes &&
                importObj.rule.nodes.find((decl) => decl.type === 'decl' && decl.prop === stylable_value_parsers_1.valueMapping.from);
            context.diagnostics.warn(fromDecl || importObj.rule, exports.diagnostics.UNKNOWN_IMPORTED_FILE(importObj.request), { word: importObj.request });
        }
        else if (resolvedImport._kind === 'css') {
            // warn about unknown named imported symbols
            for (const name in importObj.named) {
                const origName = importObj.named[name];
                const resolvedSymbol = context.resolver.resolveImported(importObj, origName);
                if (resolvedSymbol === null || !resolvedSymbol.symbol) {
                    const namedDecl = importObj.rule.nodes &&
                        importObj.rule.nodes.find((decl) => decl.type === 'decl' && decl.prop === stylable_value_parsers_1.valueMapping.named);
                    context.diagnostics.warn(namedDecl || importObj.rule, exports.diagnostics.UNKNOWN_IMPORTED_SYMBOL(origName, importObj.request), { word: origName });
                }
            }
        }
    }
}
// ToDo: move to st-symbol once symbol namespace is implemented
function REDECLARE_SYMBOL_KEYFRAMES(name) {
    return `redeclare keyframes symbol "${name}"`;
}
function checkRedeclareKeyframes(context, symbolName, node) {
    const symbol = context.meta.mappedKeyframes[symbolName];
    if (symbol) {
        context.diagnostics.warn(node, REDECLARE_SYMBOL_KEYFRAMES(symbolName), {
            word: symbolName,
        });
    }
    return symbol;
}
//# sourceMappingURL=st-import.js.map